import React, {
  forwardRef,
  HTMLAttributes,
  ReactNode,
  ReactNodeArray,
  Ref,
} from "react";

import classnames from "classnames";

import { StyledMenuFooter } from "./Styles";

export interface IMenuFooter {
  className?: string;
  children?: ReactNode | ReactNodeArray;
}

export const MenuFooter = forwardRef(
  (
    {
      children,
      className,
      ...props
    }: IMenuFooter & HTMLAttributes<HTMLDivElement>,
    ref: Ref<HTMLDivElement>
  ) => {
    return (
      <StyledMenuFooter
        {...props}
        className={classnames("c-menu-footer", className)}
        ref={ref}
      >
        {children}
      </StyledMenuFooter>
    );
  }
);

MenuFooter.displayName = "MenuFooter";
